import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import {
  cleanAddress, convertAddressToHistory, isAddressEmpty, processPhysicalAddressRule,
} from '@/store/party/partials/party-edit/helpers/pe-addresses-card'

export const PEPhysicalAddressCardActions = {
  initPePhysicalAddressCard: ({ commit }) => {
    commit('setPePhysicalAddressCardLock', true)
  },
  pePhysicalAddressCardRefresh: async ({ commit, getters }, { id }) => {
    const party = getters.peParty

    return axiosRequest.
      get(`/parties/${party.id}`).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPePhysicalAddressCardLock', true)
        commit('pePatchParty', {
          physical_address: updatedParty.physical_address,
          addresses: updatedParty.addresses,
        })
      }).
      catch(handleError)
  },
  pePhysicalAddressCardUpdate: async ({ commit, getters }, { id, section }) => {
    const party = getters.peParty
    const address = processPhysicalAddressRule(section)

    return axiosRequest.
      patch(`/parties/${party.id}/addresses/${id}`, {
        address,
      }).
      then(({ data }) => {
        const addresses = data.addresses

        commit('setPePhysicalAddressCardLock', true)
        commit('pePatchParty', {
          physical_address: addresses.find(a => a.address_type === 'physical'),
          addresses: addresses,
        })
      }).
      catch(handleError)
  },

  pePhysicalAddressMoveToHistory: async ({ dispatch }, { id, section }) => {
    const history = convertAddressToHistory(section)

    return Promise.all([
      dispatch('peResidenceHistoriesCardCreate', { section: history, index: 'new' }),
      dispatch('pePhysicalAddressCardUpdate', { id, section: cleanAddress(section) }),
    ])
  },
}

export const PEPhysicalAddressCardMutations = {
  setPePhysicalAddressCardLock: (state, lock) => {
    Vue.set(state.partyEdit.partySections, 'PhysicalAddressCard', lock)
  },
}

export const PEPhysicalAddressCardGetters = {
  pePhysicalAddressCardLock: state => state.partyEdit.partySections.PhysicalAddressCard,
  pePhysicalAddressCardIsEmpty: state => isAddressEmpty(state.partyEdit.party.physical_address),
  pePhysicalAddress: state => state.partyEdit.party.physical_address,
}
